import React, { useState, useEffect } from 'react';
import { getUtxos } from '../services/utxoService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';

const TransactionsUtxos = () => {
  const [utxos, setUtxos] = useState([]);

  useEffect(() => {
    const fetchUtxos = async () => {
      try {
        const result = await getUtxos();
        setUtxos(result.utxos);
      } catch (error) {
        console.error('Error fetching UTXOs:', error);
      }
    };

    fetchUtxos();
    const intervalId = setInterval(fetchUtxos, 5000); // 5s

    // Limpiar
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="container mt-5">
      <h1 className="text-center">
        <FontAwesomeIcon icon={faCoins} /> UTXOs
      </h1>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead className="thead-dark">
            <tr>
              <th>Cantidad (Satoshis)</th>
              <th>Estado</th>
              <th>Dirección</th>
              <th>TxID</th>
              <th>Vout</th>
              <th>Script Pub Key</th>
            </tr>
          </thead>
          <tbody>
            {utxos.map((utxo, index) => (
                <tr key={index}>
                <td>{utxo.amount_satoshis}</td>
                <td>{utxo.is_spent ? 'Gastado' : 'Disponible'}</td>
                <td>{utxo.address}</td>
                <td>{utxo.txid}</td>
                <td>{utxo.vout}</td>
                <td>{utxo.script_pub_key}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionsUtxos;
